import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import httpClient from "../utils/httpClients";

function ArtistFoot() {
  const [loading, setLoading] = useState(true);
  const [contentData, setContentData] = useState([]);

  const fetchContent = async () => {
    try {
      setLoading(true);
      const res = await httpClient.get("/user/content/all-content");
      if (res.data.success) {
        const contentList = res.data.data?.getAllContentData || [];
        setContentData(contentList);
      } else {
      }
    } catch (err) {
      console.error("Error fetching content:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchContent();
  }, []);

  return (
    <>
      <div className="card border-top mb-0">
        <div className="card-body footer1">
          <div className="d-flex align-items-center justify-content-between flex-md-row flex-column gap-3">
            {/* Left side links */}
            <div>
              <ul className="list-unstyled p-0 m-0 mb-3 text-capitalize d-flex gap-3 flex-md-nowrap flex-wrap">
                {contentData.map((item, index) => (
                  <React.Fragment key={item._id}>
                    {index > 0 && <li>|</li>}
                    <li>
                      <Link to={`/artist/${item.key}`} style={{ cursor: "pointer" }}>
                        {item.title}
                      </Link>
                    </li>
                  </React.Fragment>
                ))}

                {/* Static content - Events and FAQ */}
                {contentData.length > 0 && <li>|</li>}
                
                <li>|</li>
                <li>
                  <Link to="/artist/faq">FAQ</Link>
                </li>
              </ul>

              <small>
                Copyright <span id="copyright">{new Date().getFullYear()}</span>
                . Made by Webmobril Inc.
              </small>
            </div>

            {/* Right side social icons */}
            <div>
              <ul className="list-unstyled m-0 p-0 d-flex align-items-center gap-3">
                <li>
                  {/* Twitter */}
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={16}
                    height={16}
                    viewBox="0 0 16 16"
                    fill="none"
                  >
                    <path
                      d="M14.973 4.753a5.711 5.711 0 0 1-1.64.46 2.872 2.872 0 0 0 1.26-1.586 5.724 5.724 0 0 1-1.82.694 2.864 2.864 0 0 0-4.88 2.614 8.134 8.134 0 0 1-5.9-2.993 2.863 2.863 0 0 0 .887 3.825 2.844 2.844 0 0 1-1.3-.36v.036a2.865 2.865 0 0 0 2.298 2.81 2.888 2.888 0 0 1-1.294.05 2.866 2.866 0 0 0 2.675 1.99 5.746 5.746 0 0 1-4.245 1.186 8.102 8.102 0 0 0 4.39 1.288c5.266 0 8.146-4.362 8.146-8.146 0-.124-.003-.248-.009-.371a5.825 5.825 0 0 0 1.432-1.5l-.001-.001z"
                      fill="#4A525F"
                    />
                  </svg>
                </li>
                <li>
                  {/* LinkedIn */}
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={16}
                    height={16}
                    viewBox="0 0 16 16"
                    fill="none"
                  >
                    <path
                      d="M14.815 0H1.175C0.526 0 0 .513 0 1.146V14.854C0 15.487 0.526 16 1.175 16H14.825C15.474 16 16 15.487 16 14.854V1.146C16 .513 15.474 0 14.825 0h-.01zM4.744 13.634H2.373V5.996h2.371v7.638zM3.559 4.955c-.76 0-1.375-.616-1.375-1.376 0-.76.615-1.376 1.375-1.376.76 0 1.376.616 1.376 1.376 0 .76-.616 1.376-1.376 1.376zm10.075 8.679h-2.371V9.921c0-.885-.016-2.024-1.234-2.024-1.234 0-1.422.964-1.422 1.96v3.777H6.236V5.996h2.275v1.04h.032c.315-.6 1.088-1.234 2.241-1.234 2.398 0 2.84 1.577 2.84 3.627v4.205h-.001z"
                      fill="#4A525F"
                    />
                  </svg>
                </li>
                <li>
                  {/* Facebook */}
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={16}
                    height={16}
                    viewBox="0 0 16 16"
                    fill="none"
                  >
                    <path
                      d="M16 8.049C16 3.603 12.418 0 8 0S0 3.603 0 8.049c0 4.019 2.926 7.347 6.75 7.951v-5.625h-2.03V8.049h2.03V6.276c0-2.013 1.195-3.126 3.022-3.126.876 0 1.792.157 1.792.157v1.97h-1.009c-.995 0-1.305.619-1.305 1.253v1.503h2.218l-.355 2.326H9.25V16C13.074 15.396 16 12.068 16 8.049z"
                      fill="#49525e"
                    />
                  </svg>
                </li>
                <li>
                  {/* Instagram */}
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={16}
                    height={16}
                    viewBox="0 0 16 16"
                    fill="none"
                  >
                    <path
                      d="M8 0C5.829 0 5.556.01 4.703.048 3.85.088 3.27.222 2.76.42a3.92 3.92 0 0 0-1.417.923A3.92 3.92 0 0 0 .42 2.76C.222 3.27.087 3.85.048 4.7.01 5.556 0 5.829 0 8s.01 2.444.048 3.297c.04.852.174 1.433.372 1.943.205.526.478.972.923 1.417.445.445.89.718 1.416.923.51.198 1.092.332 1.943.372C5.556 15.99 5.829 16 8 16s2.444-.01 3.298-.048c.851-.04 1.434-.174 1.943-.372a3.92 3.92 0 0 0 1.417-.923c.445-.445.718-.89.923-1.417.198-.51.332-1.092.372-1.943C15.99 10.444 16 10.171 16 8s-.01-2.444-.048-3.297c-.04-.851-.174-1.434-.372-1.943a3.92 3.92 0 0 0-.923-1.417A3.92 3.92 0 0 0 13.24.42c-.51-.198-1.092-.332-1.943-.372C10.444.01 10.171 0 8 0zm0 1.44c2.136 0 2.39.01 3.233.048.78.036 1.203.166 1.485.276.374.146.64.318.92.598.28.28.452.546.598.92.11.282.24.705.276 1.485.038.844.048 1.097.048 3.233s-.01 2.39-.048 3.233c-.36.78-.166 1.203-.276 1.485a2.5 2.5 0 0 1-.598.92c-.28.28-.546.452-.92.598-.282.11-.705.24-1.485.276-.844.038-1.097.048-3.233.048s-2.39-.01-3.233-.048c-.78-.036-1.203-.166-1.485-.276a2.5 2.5 0 0 1-.92-.598 2.5 2.5 0 0 1-.598-.92c-.11-.282-.24-.705-.276-1.485C1.45 10.39 1.44 10.136 1.44 8s.01-2.39.048-3.233c.036-.78.166-1.203.276-1.485.146-.374.318-.64.598-.92.28-.28.546-.452.92-.598.282-.11.705-.24 1.485-.276C5.61 1.45 5.864 1.44 8 1.44zm0 2.452a4.108 4.108 0 1 0 0 8.216 4.108 4.108 0 0 0 0-8.216zM8 10.6a2.54 2.54 0 1 1 0-5.08 2.54 2.54 0 0 1 0 5.08zm5.271-6.6a.96.96 0 1 1-1.92 0 .96.96 0 0 1 1.92 0z"
                      fill="#4A525F"
                    />
                  </svg>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default ArtistFoot;
